
import { modalActionTypes } from '@constants/actionTypes/commonActionTypes';
import { ssapModalTypes } from '@constants/ssap/modals/ssapModalTypes';

export const INITIAL_STATE = [];

/**
 *
 * @function: modalReducer
 * @param {Object} state: current state of "modal" prop in Redux Store
 * @param {Object} action
 * @returns {Object}: the same or updated or initial state
 */
export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
    /**
     *
     * ActionCreator - showModal
     * This action invokes certain Modal appearance on UI and if it is needed provides data and callbacks in it
     */
        case modalActionTypes.SHOW_MODAL:
            return !state.some(m => m.modalType === action.modalType) ? 
                [
                    ...state,
                    {
                        modalType: action.modalType,
                        modalData: action.modalData ? action.modalData : null,
                        zIndex: 10000 * (state.length + 1)
                    }
                ] : state;

            /**
             *
             * ActionCreator - hideModal
             * This action removes Modal from UI and clears state
             */
        case modalActionTypes.HIDE_MODAL:
            return state.filter(modal => modal.modalType !== action.modalType);

        case modalActionTypes.HIDE_ALL_MODALS:
            return INITIAL_STATE;

        /**
         *
         * ActionCreator - clearState
         * Returns Redux Store to initial state and modalReducer as part of it as well
         */
        case modalActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;

        /**
         *
         * Returns the same value if another reducer was invoked
         *
        */
        default:
            return state;
    }
};

// Selectors

export const isLeaveModalShown = state => state.some(modal => modal.modalType === ssapModalTypes.LEAVE_PAGE_MODAL);